import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import ViewRecent from "./ViewRecent";
import ViewAllocated from "./ViewAllocated";
import ViewClosed from "./ViewClosed";
import StatusComp from "../../components/StatusComp";
import { useAdmin } from "../../components/Common/FilterContext/AdminPanelContext";

const AdminNotificationsComp = () => {
  const location = useLocation();
  const data = location.state?.data;
  const type = location?.state?.type;
  const navigate = useNavigate();
  const createdAt = moment().format("DD-MM-YYYY");
  const { savePageState, getPageState } = useAdmin();

  const siteKey = `${location.pathname}_${location?.state?.data?.id}`;
  const saved = getPageState(siteKey);

  const [activeTab, setActiveTab] = useState(saved?.activeTab || "Recent");

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    savePageState(siteKey, {
      activeTab: type,
      btnTab: 2,
    });
  };

  return (
    <div className="">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && <ViewRecent site={type} />}
        {activeTab === "Allocated" && <ViewAllocated site={type} />}
        {activeTab === "Closed" && <ViewClosed site={type} />}
      </div>
    </div>
  );
};

export default AdminNotificationsComp;
